import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { ReportMessageSettingsAction } from '../../../domains/reportMessage/settingsActions.types';

import type { NetworkReportMessageSettingsMap } from './types';

export type NetworkReportMessageSettingsAction = ReportMessageSettingsAction;

const initialState: NetworkReportMessageSettingsMap = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<NetworkReportMessageSettingsMap, NetworkReportMessageSettingsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'MESSAGE.LOAD_REPORT_SETTINGS_PENDING':
      return moveToPending(state, [action.networkId]);
    case 'MESSAGE.LOAD_REPORT_SETTINGS_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload });
    case 'MESSAGE.LOAD_REPORT_SETTINGS_REJECTED':
      return moveToRejected(state, [action.networkId], action.payload.error);
    default:
      return state;
  }
};

export default reducer;
